import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    closeOthers: Boolean
  }

  toggle(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const revealId = button.dataset.revealsId
    const revealedItem = this.element.querySelector(`[data-revealed-by="${revealId}"]`)
    
    if (!revealedItem) return

    // Close other revealed items in same scope if configured
    if (this.closeOthersValue && !revealedItem.classList.contains('revealed')) {
      this.element.querySelectorAll('.revealed').forEach(item => {
        item.classList.remove('revealed')
      })
    }

    // Toggle the revealed state
    revealedItem.classList.toggle('revealed')

    // Toggle button text if inverse-text is set
    const inverseText = button.dataset.inverseText
    if (inverseText) {
      const currentText = button.innerHTML
      button.innerHTML = inverseText
      button.dataset.inverseText = currentText
    }
  }
}
